import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import Api from './../../../Global/Modules/Api'
class PersoonlijkeGegevens extends Component {
    constructor(props) {
        super(props)
        this.getMemberInfo = this.getMemberInfo.bind(this)
    }

    getMemberInfo() {
        let data = this.props.data
        return data ?
            <tbody>
                <tr>
                    <td>Titel</td>
                    <td>{data.title}</td>
                </tr>
                <tr>
                    <td>Voornaam</td>
                    <td>{data.firstName}</td>
                </tr>
                <tr>
                    <td>Voorletters</td>
                    <td>{data.initials}</td>
                </tr>
                <tr>
                    <td>Tussenvoegsel</td>
                    <td>{data.middleName}</td>
                </tr>
                <tr>
                    <td>Achternaam</td>
                    <td>{data.lastName}</td>
                </tr>
                <tr>
                    <td>Registernummer</td>
                    <td>{data.registerNumber}</td>
                </tr>
                <tr>
                    <td>Status</td>
                    <td>{data.status}</td>
                </tr>
                <tr>
                    <td>Adres</td>
                    <td>{data.address}</td>
                </tr>
                <tr>
                    <td>Postcode</td>
                    <td>{data.postCode}</td>
                </tr>
                <tr>
                    <td>Plaats</td>
                    <td>{data.city}</td>
                </tr>
                <tr>
                    <td>Telefoon prive</td>
                    <td>{data.phone}</td>
                </tr>
                <tr>
                    <td>Telefoon mobiel</td>
                    <td>{data.mobile}</td>
                </tr>
                <tr>
                    <td>Telefoon werk</td>
                    <td>{data.phoneWork}</td>
                </tr>
                <tr>
                    <td>Email</td>
                    <td>{data.email}</td>
                </tr>
                <tr>
                    <td>Geboorte datum</td>
                    <td>{Api.formatDate(data.birthDate)}</td>
                </tr>
                <tr>
                    <td>Geslacht</td>
                    <td>{data.gender}</td>
                </tr>
                <tr>
                    <td>Bedrijfsnaam</td>
                    <td>{data.company}</td>
                </tr>
                <tr>
                    <td>Bedrijfsadres</td>
                    <td>{data.companyAddress}</td>
                </tr>
                <tr>
                    <td>Bedrijfspostcode</td>
                    <td>{data.companyPostCode}</td>
                </tr>
                <tr>
                    <td>Bedrijfsplaats</td>
                    <td>{data.companyCity}</td>
                </tr>
                <tr>
                    <td>Bedrijfswebsite</td>
                    <td>{data.companyWebsite}</td>
                </tr>
                <tr>
                    <td>Functie</td>
                    <td>{data.function}</td>
                </tr>
                <tr>
                    <td>Datum aanvraag</td>
                    <td>{data.requestDate}</td>
                </tr>
                <tr>
                    <td>Status aanvraag</td>
                    <td>{data.requestStatus}</td>
                </tr>
            </tbody> : null
    }
    render() {
        return (
            <div className="rapport">
                <h5><strong>Persoonlijke Gegevens</strong></h5>
                <Table responsive bordered className="persoonlijkeGegevens">
                    {this.getMemberInfo()}
                </Table>
            </div>
        );
    }
}

export default PersoonlijkeGegevens;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Rapport/PersoonlijkeGegevens.js